<script>
export default {
  name: 'LegacyLogoAndText',
  props: {
    logo: { type: String, default: '' },
    text: { type: String, default: '' },
  },
  computed: {
    logoSrc() {
      return this.logo || ''
    },
  },
}
</script>

<template>
  <div class="flex items-center gap-2">
    <img
      v-if="logoSrc"
      :src="logoSrc"
      class="w-6 h-6 rounded object-contain border border-border bg-white flex-shrink-0"
      alt=""
    />
    <span class="text-sm font-medium text-foreground truncate">{{ text }}</span>
  </div>
</template>
